import React, { FC, useState } from "react";
import { useIntl } from "react-intl";
import { formatPrice } from "../../selectors";
import { HeaderModel } from "../../models/CommonModel";
import SortableColumn from "../../components/Table/SortableColumn";
import { WareHouseModel } from "../../models/WarehouseReportModel";

interface IRow {
    item: WareHouseModel
}

type Props = {
    data: Array<WareHouseModel>,
    header: HeaderModel[],
    hideCols: string[],
    openColConfig: () => void,
    handleSort: (sortBy: string, direction: 'asc' | 'desc' | 'none') => void
};
const WareHouseTable: FC<Props> = ({ data, header, hideCols, openColConfig, handleSort }) => {

    const intl = useIntl();

    const Row: FC<IRow> = ({ item }) => {

        let price = item?.origin_price ?? (item?.product?.price ?? 0);
        let vat = item?.product?.vat ?? 0;
        let saleAmount = item?.total_sales_amount ?? 0;
        let saleQty = item?.total_sales_qty ?? 0;
        let consignQty = item?.total_consign_qty ?? 0;
        let consignAmount = item?.total_consign_amount ?? 0;
        let refundQty = item?.total_refund_qty ?? 0;
        let refundAmount = item?.total_refund_amount ?? 0;
        return (
            <tr key={`warehouse_${item.id}`} className="cursor-pointer">
                <td></td>
                {!hideCols.includes('product_name') && (
                <td
                >{item?.product?.name || ''}</td>
                )}
                {!hideCols.includes('store_name') && (
                <td>{item?.store?.name || ''}</td>
                )}
                {!hideCols.includes('action') && (
                <td>{ consignQty + '/' + (saleQty - refundQty) }</td>
                )}
                {!hideCols.includes('price') && (
                <td>{formatPrice(price)}</td>
                )}
                {!hideCols.includes('vat') && (
                <td>{vat}</td>
                )}
                {!hideCols.includes('amount') && (
                <td>{ formatPrice(saleAmount - refundAmount)}</td>
                )}
                {!hideCols.includes('total_remain') && (
                <td><span>{ item?.quantity ?? 0}</span></td>
                )}
            </tr>
        )
    }

    return <>
        <div className='table-responsive'>
            <table className="table table-hover table-bordered table-striped border gy-7 gs-7">
                <thead>
                    <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                        <th>
                            <i
                                className="fa fa-cogs"
                                style={{ cursor: 'pointer' }}
                                onClick={openColConfig}
                            ></i>
                        </th>
                        {header.map((th, index) => {
                            if (!hideCols.includes(th.field)) {
                                if (th.sortable) {
                                    return (
                                        <SortableColumn
                                            key={'th-' + index}
                                            sortBy={th?.field}
                                            onSortChange={handleSort}
                                            style={th?.style ?? {}}
                                        >
                                            {th.label}
                                        </SortableColumn>
                                    )
                                }
                                return (
                                    <th style={th?.style ?? {}}>{th.label}</th>
                                )
                            }
                        })}
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item: WareHouseModel) => <Row item={item} />)}
                </tbody>
            </table>
        </div>
    </>
}
export default WareHouseTable;